module.exports = __webpack_public_path__ + "img/midwest-winter-1920x550.26717c31.jpg";